import script from "./resultSuggestionsTags.vue?vue&type=script&setup=true&lang=js"
export * from "./resultSuggestionsTags.vue?vue&type=script&setup=true&lang=js"

import "./resultSuggestionsTags.vue?vue&type=style&index=0&id=24b9aa03&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b9aa03"]])

export default __exports__